import * as React from 'react';

import '../../Main.scss';
import './FinancialStatements.scss';

import FilterIcon from '@mui/icons-material/FilterList';

import {
    Button,
    Popover,
    PopoverBody,
    Container,
    Row,
    Col,
    Input
} from 'reactstrap';

import {
    Tooltip
} from '@mui/material';

import {
    FinancialStatementLineItemFilter,
} from '../../../Store/FinancialStatements';

import { PortalTextFinancialStatements } from '../../../Models/Api/strongbox.financialportal';

import { LineItemTypeToDescription } from './Utilities';

import { FSModels } from '@finagraph/financial-statement-editor';

const idFilterAnchor = 'financial-statement-table-line-item-filter-toggle';

type FilterButtonProps = {
    onFilterLineItems: () => void;
    dropdownActive: boolean;
    financialStatementsText?: PortalTextFinancialStatements;
}

export const FilterDropdownButton: React.FC<FilterButtonProps> = (props): React.ReactElement => {
    const {
        dropdownActive,
        onFilterLineItems,
        financialStatementsText,
    } = props;

    const renderButton = (): React.ReactElement => {
        return (
            <Button
                className={'header'}
                onClick={() => onFilterLineItems()}
                id={idFilterAnchor}
                color="primary"
            >
                <FilterIcon />
            </Button>
        )
    }

    return (
        <Tooltip
            title={!dropdownActive ? (financialStatementsText?.filterByLineItemTooltip || '') : ''}
        >
            {renderButton()}
        </Tooltip>
    )
}

type Props = {
    onToggle: (active: boolean) => void;
    filters: FinancialStatementLineItemFilter[];
    statementType: FSModels.FinancialStatementType;
    onFilterStateChange: (filterType: FSModels.FinancialStatementLineItemType, newState: boolean) => void;
    financialStatementsText?: PortalTextFinancialStatements;
}

export const FilterDropdown: React.FC<Props> = (props): React.ReactElement => {
    const {
        onToggle,
        filters,
        statementType,
        onFilterStateChange,
        financialStatementsText,
    } = props;

    const getSelectionRow = (filter: FinancialStatementLineItemFilter): React.ReactElement => {
        return (
            <Row key={`financial-statement-filter-dropdown-${statementType}-${filter.type}`}>
                <Col xs={2}>
                    <Input
                        className={'clickable'}
                        type={'checkbox'}
                        checked={filter.state}
                        onChange={(e) => {
                            onFilterStateChange(filter.type, !filter.state);
                        }}
                    />
                </Col>
                <Col>
                    <span
                        className={'clickable'}
                        onClick={(e) => {
                            onFilterStateChange(filter.type, !filter.state);
                        }}
                    >
                        {LineItemTypeToDescription(filter.type, financialStatementsText)}
                    </span>
                </Col>
            </Row>
        )
    }

    return (
        <div className={`control-region control-region-lender`}>
            <Popover
                placement={'bottom'}
                hideArrow={true}
                isOpen={true}
                className={'financial-statement-popover'}
                target={idFilterAnchor}
                key={'fs-filter-line_items-popover'}
                toggle={() => onToggle && onToggle(false)}
                trigger={'legacy'}
            >
                <PopoverBody className={'popover-body menu-style'}>
                    <Container fluid>
                        {
                            filters.map(f => getSelectionRow(f))
                        }
                    </Container>
                </PopoverBody>
            </Popover>
        </div>
    )
}
